<template>
  <div class="infographics-item" :class="{'long-row': !boxShaped}">
      <span><svg-icon color="#545b62" :url="item.icon_url" /></span>
      <div class='value-wrapper'>
         <div class='value-title'>{{ item.title }}</div>
         <div class="value">{{ item.value==null ? '-' : item.value }}</div>
      </div>
   </div>
</template>

<script>
import SvgIcon from '../../../atoms/Home/SvgIcon';

export default {
   name: 'infographics-item',
   components: {
      SvgIcon,
   },
   props: {
      item: {
         type: Object,
         required: true,
         validator: item =>  item.id && item.title && item.icon_url,
      },
      boxShaped: {
         type: Boolean,
         default: false,
      }
   }
}
</script>

<style lang="scss" scoped>
$border-color: lighten($secondary-color, 40%);

.infographics-item {
   border: solid 1px $border-color;
   text-align: center;
   padding: 12px;
   display: flex;
   flex-direction: column;
   justify-content: center;

   > span {
      display: block;
   }
   .value-wrapper {
      .value-title {
         font-weight: 400;
         color: $font-color;
         font-size: 0.94em;
         font-family: $primary-font;
      }
      .value {
         margin-top: auto;
         color: lighten($font-color, 15%);
         font-size: 0.72em;
         font-weight: 600;
         font-family: $secondary-font;
      }
   }

   &.long-row {
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: row;

      padding: 3px 10px;
      margin: 0px 10px;
      border: none;
      border-bottom: solid 1px $border-color;
      i {
         margin-top: 0.3em;
      }
      .value-wrapper {
         margin-left: 8px;
         text-align: left;
      }
   }
}

</style>